import { render, staticRenderFns } from "./DocsItem.vue?vue&type=template&id=b8567738&"
import script from "./DocsItem.vue?vue&type=script&lang=js&"
export * from "./DocsItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports